// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".moving-container[data-v-6d363272]{bottom:15px;margin-bottom:0;padding:0 40px 0 12px;position:fixed;width:100%!important;z-index:100}@media screen and (min-width:768px){.moving-container[data-v-6d363272]{left:12px;max-width:351px;padding:0}.travel-badge-wrapper[data-v-6d363272]{max-width:351px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
